import { type ApartmentQueue } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { apartmentQueueFilters } from '@/app/settings/modules/market/queues/apartment-queues/filters';

export const ApartmentQueueItem: RelationFieldProps<ApartmentQueue> = {
  filters: apartmentQueueFilters,
  renderItem: (item) => ({
    title: item?.name ?? '',
    descriptionItems: <></>,
  }),
};
